/**
 * IntakeLinkStatusBadge — badge sémantique pour les 4 statuts dérivés
 * exposés par GET /v1/intake-links (chunk 9.N.3.A.0).
 *
 * Préséance affichée (= préséance de calcul SQL) :
 *   revoked > quota_reached > expired > active
 *
 * Palette sobre brand-aligned (cf. décisions PO 9.N.3.A) :
 *   - active        → emerald (vivant, OK pour soumissions)
 *   - expired       → amber (info doux non-anxiogène, parité InvalidState 9.N.2)
 *   - revoked       → red (terminal explicite — broker l'a coupé)
 *   - quota_reached → slate (neutre — ce n'est pas une erreur, juste un état
 *                              actionnable « créer un nouveau lien »)
 *
 * a11y : pas d'icône-only — le label texte est traduit FR/EN. Couleur en
 * supplément (WIG : never rely on color alone). Contraste AA respecté
 * (text-{tone}-700 sur bg-{tone}-50).
 */

import type { IntakeLinkStatus } from "@kollectivia/shared";
import { useTranslation } from "react-i18next";

const PALETTE: Record<IntakeLinkStatus, string> = {
  active: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  expired: "bg-amber-50 text-amber-700 ring-amber-200",
  revoked: "bg-red-50 text-red-700 ring-red-200",
  quota_reached: "bg-slate-100 text-slate-700 ring-slate-200",
};

type Props = {
  status: IntakeLinkStatus;
  className?: string;
};

export function IntakeLinkStatusBadge({ status, className }: Props) {
  const { t } = useTranslation();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset ${PALETTE[status]} ${className ?? ""}`}
    >
      {t(`intake_links.statuses.${status}`)}
    </span>
  );
}
